/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Status_InitializingInputs */

const en_iframe_remote_status_initializing = /** @type {(inputs: Iframe_Remote_Status_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initializing...`)
};

const fr_iframe_remote_status_initializing = /** @type {(inputs: Iframe_Remote_Status_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initialisation...`)
};

const de_iframe_remote_status_initializing = /** @type {(inputs: Iframe_Remote_Status_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initialisierung läuft...`)
};

const it_iframe_remote_status_initializing = /** @type {(inputs: Iframe_Remote_Status_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizializzazione in corso...`)
};

const ru_iframe_remote_status_initializing = /** @type {(inputs: Iframe_Remote_Status_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инициализация...`)
};

const es_iframe_remote_status_initializing = /** @type {(inputs: Iframe_Remote_Status_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicializando...`)
};

const zh_cn2_iframe_remote_status_initializing = /** @type {(inputs: Iframe_Remote_Status_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在初始化...`)
};

const ja_iframe_remote_status_initializing = /** @type {(inputs: Iframe_Remote_Status_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初期化中...`)
};

const hi_iframe_remote_status_initializing = /** @type {(inputs: Iframe_Remote_Status_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आरंभ हो रहा है...`)
};

const pt_pt2_iframe_remote_status_initializing = /** @type {(inputs: Iframe_Remote_Status_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicializando...`)
};

/**
* | output |
* | --- |
* | "Initializing..." |
*
* @param {Iframe_Remote_Status_InitializingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_status_initializing = /** @type {((inputs?: Iframe_Remote_Status_InitializingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Status_InitializingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_status_initializing(inputs)
	if (locale === "de") return de_iframe_remote_status_initializing(inputs)
	if (locale === "it") return it_iframe_remote_status_initializing(inputs)
	if (locale === "ru") return ru_iframe_remote_status_initializing(inputs)
	if (locale === "es") return es_iframe_remote_status_initializing(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_status_initializing(inputs)
	if (locale === "ja") return ja_iframe_remote_status_initializing(inputs)
	if (locale === "hi") return hi_iframe_remote_status_initializing(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_status_initializing(inputs)
	return en_iframe_remote_status_initializing(inputs)
});